import axios from 'axios';
import { LuckyCardStateParams } from './luckyCard.types';

export const luckyCardState = async (params: LuckyCardStateParams) => {
  return axios.request<''>({
    method: 'get',
    url: '/gpt/lucky-card/public/api/v1/feature/state',
    params
  });
};
